import { Subscriber, Subscription } from 'rxjs';

export function DestroySubscribers() {
  return (target: any) => {
    target.prototype.ngOnDestroy = ngOnDestroyDecorator(target.prototype.ngOnDestroy);

    function ngOnDestroyDecorator(f) {
      return function (...args: unknown[]) {
        const superData = f ? f.apply(this, args) : null;

        for (const subscriberKey in this.subscribers) {
          if (Object.prototype.hasOwnProperty.call(this.subscribers, subscriberKey)) {
            const subscriber = this.subscribers[subscriberKey];
            if (subscriber instanceof Subscriber) {
              subscriber.unsubscribe();
            }
          }
        }

        return superData;
      };
    }

    return target;
  };
}

export type ISubscribers = Record<string, Subscription>;
